import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-data",
  "use": "icon-nav-data-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-nav-data\">\r\n<path d=\"M181.8,28.9H100V9.6c0-5.3-4.1-9.6-9.1-9.6H9.1C4.1,0,0,4.3,0,9.6v171.1C0,191.4,8.1,200,18.2,200h163.6\r\n\tc10,0,18.2-8.6,18.2-19.3V48.1C200,37.5,191.9,28.9,181.8,28.9z M172.2,105.7v0.2H27.8c-3.1,0-5.6-2.6-5.6-5.9s2.5-5.9,5.6-5.9h12\r\n\tL56,64.2c3.1-5.6,9.9-7.6,15.2-4.3l55.9,34h45.1c3.1,0,5.6,2.6,5.6,5.9C177.8,103.1,175.3,105.7,172.2,105.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/nav/nav-data.svg
// module id = OWeL
// module chunks = 13